import type { ReactNode } from "react";
import { cx } from "../ui/cx";

/** A card for a block of its own (`.k-card`). `flush` lets its content reach the edges; `hero` is the warm one. */
export function SeasonCard({
  flush = false,
  hero = false,
  label,
  className,
  children,
}: {
  flush?: boolean;
  hero?: boolean;
  /** Names the card for a screen reader and makes it a region. */
  label?: string;
  className?: string;
  children: ReactNode;
}) {
  const cls = cx("k-card", flush && "k-flush", hero && "k-hero", className);
  return label ? (
    <section className={cls} aria-label={label}>
      {children}
    </section>
  ) : (
    <div className={cls}>{children}</div>
  );
}
